export const qualityUploadedFiles = 0.5;
